export interface ManagerUserData {
    accountKey: number,
    managerKey: number,
    identifiant: string,
    role: string,
    lastName: string,
    firstName: string,
    mail: string,
    phoneNumber: string,
    actif: boolean,
    dateBlocage: string
}


/** Builds and returns a new SearchResultData. */
export function buildManagerUserData(data: any): ManagerUserData {
    return {
      accountKey: data.accountKey,
      managerKey: data.managerKey,
      identifiant: data.identifiant,
      role: data.role,
      lastName: data.lastName,
      firstName: data.firstName,
      mail: data.mail,
      phoneNumber: data.phoneNumber,
      actif: data.actif,
      dateBlocage: data.dateBlocage
    };
  }
  